import { motion } from 'framer-motion';
import React from 'react';
import { useCustomCollapseStore } from 'src/store/layout/useCustomCollapseStore';


interface CustomCollapseProps {
  items: { title: string; description?: string; links: { label: string, href: string }[] }[];
}

const CustomCollapse: React.FC<CustomCollapseProps> = ({ items }) => {
  const activeKey = useCustomCollapseStore((state) => state.activeKey);
  const setActiveKey = useCustomCollapseStore((state) => state.setActiveKey);
  const toggleCollapse = (key: string) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className="w-full">
      {items.map((item, index) => (
        <div key={index} className="mb-4">
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cursor-pointer"
            onClick={() => toggleCollapse(index.toString())}
          >
            <div
              className="flex justify-between items-center p-4 text-white border"
              style={{
                backgroundColor: activeKey === index.toString() ? 'transparent' : 'transparent',
                borderRadius: '8px',
                transition: 'background-color 0.3s ease',
              }}
            >
              <h3>{item.title}</h3>
              <span>{activeKey === index.toString() ? '▲' : '▼'}</span>
            </div>
          </motion.div>
          {activeKey === index.toString() && (
            <div className="bg-transparent p-4 text-gray-300">
              {item.description && (
                <p className="text-gray-400 mb-4">{item.description}</p>
              )}
              <ul>
                {item.links.map((link, idx) => (
                  <li key={idx} className="py-2 hover:text-white">
                    <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CustomCollapse;